export const ITAU_ONIX = ['7101', '7102', '7103', '6099', '6100', '6101'];

export const isItauOnix = (onixCode: string | null = ''): boolean =>
  ITAU_ONIX.includes(onixCode?.toString() || '');
